<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('id')">
              id
              <i
                :class="
                  currentSort === 'id'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('desc')">
              desc
              <i
                :class="
                  currentSort === 'desc'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('updatedAt')">
              Last Modified Date
              <i
                :class="
                  currentSort === 'updatedAt'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('update_by')">
              Last Modified By
              <i
                :class="
                  currentSort === 'update_by'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('active')">
              active
              <i
                :class="
                  currentSort === 'active'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('note')">
              catatan
              <i
                :class="
                  currentSort === 'note'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td>{{ list.desc }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.active ? 'color:green' : 'color:red'">
              {{ list.active ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <GoldenRules
      v-if="showModalEdit"
      :editData="editData"
      @closeModal="closeModal"
      class="notAll"
    />
  </div>
</template>

<script>
export default {
  components: {
    GoldenRules: () => import('@/views/MasterData/Edit/K3L/GoldenRules.vue'),
  },

  props: {
    isEdit: Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: '',
        desc: '',
        updatedAt: '',
        update_by: '',
        active: '',
        note: '',
      },
      data: [
        {
          id: '1',
          desc: 'Kelayakan Kendaraan & Unit',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 1',
        },
        {
          id: '2',
          desc: 'Pengoperasian Kendaraan & Unit',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 2',
        },
        {
          id: '3',
          desc: 'Log out dan Tag Out',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 3',
        },
        {
          id: '4',
          desc: 'Keselamatan Bekerja di Ketinggian',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 4',
        },
        {
          id: '5',
          desc: 'Keselamatan Bekerja di Ruang Terbatas',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 5',
        },
        {
          id: '6',
          desc: 'Keselamatan Alat Angkat & alat Penyangga',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 6',
        },
        {
          id: '7',
          desc: 'Bekerja di dekat tebing & dinding galian',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 7',
        },
        {
          id: '8',
          desc: 'Bekerja pada Area Peledakan',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 8',
        },
        {
          id: '9',
          desc: 'Bekerja di Dekat Air',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 9',
        },
        {
          id: '10',
          desc: 'Bekerja di Disposal',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 10',
        },
        {
          id: '11',
          desc: 'Bekerja pada area pembersihan lahan',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 11',
        },
      ],
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        desc: data.desc,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        active: data.active,
        note: data.note,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
  },

  computed: {
    goldenRulesData() {
      const result = this.$store.state.mdDatabaseStore.goldenRulesData
      return result
    },
    sortedData() {
      return this.goldenRulesData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },
}
</script>
